import React from "react";
import "./index.scss";
import RadioButton from "../RadioButton/RadioButton";

const SectionItemRadioButton = ({ item, column, value, onPropChange }) => {
    return (
        <RadioButton 
            onChange={() => onPropChange({[column.accessor]: !value})}
            value={value} 
        />
    )};

export default SectionItemRadioButton;
